import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['input']
  static values = { url: String }

  connect() {
    this.bloodhound = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.whitespace,
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: this.urlValue,
        prepare: this.prepare.bind(this)
      }
    })

    $(this.inputTarget).typeahead(
      { highlight: true, minLength: 3 },
      { source: this.bloodhound }
    )
    $(this.element).on('typeahead:select', (event, obj) => {
      this.dispatch('selected', { detail: { selectionObj: obj } })
    })
  }

  prepare(query, settings) {
    settings.url = this.buildURL(query)
    return settings
  }

  get form() {
    return this.element
  }

  buildURL(query) {
    const currentParams = new URLSearchParams(location.search);
    currentParams.set('q', query)
    return `${this.urlValue}?${currentParams.toString()}`
  }
}
